<div class="body">
  <div class="container h-screen w-screen flex align-items-center justify-content-center text-center">
    <div>
      <img src="logo.png" alt="Logo" class="logo" width="128">

      <h2>{{ translations.auth.dashboard | translate }}</h2>

      <!--        <div class="flex flex-row mb-6">-->
      <!--            <app-language-selector style="margin: auto" [colorized]="false"></app-language-selector>-->
      <!--        </div>-->

      <div class="surface-card py-7 px-5 sm:px-7 mx-auto shadow-2 flex flex-column w-11 sm:w-30rem"
           style="border-radius:14px">
        <h1 class="font-bold text-2xl mt-0 mb-2">{{ translations.auth.recoverPassword | translate }}</h1>

        <ng-template [ngIf]="!passwordChanged">
          <p class="text-color-secondary mb-4">{{ translations.auth.setNewPassword | translate }}</p>
          <form #form='ngForm' class="login-form mb-3 fluid flex-column text-center" (ngSubmit)="resetPassword()">
            <div class="field">
              <input pInputText name="password" type="password"
                     autocomplete="off"
                     [placeholder]="translations.auth.password | translate"
                     required
                     class="inputfield w-full"
                     [(ngModel)]="password">
            </div>
            <div class="field">
              <input pInputText name="password" type="password"
                     autocomplete="off"
                     [placeholder]="translations.auth.repeatPassword | translate"
                     required
                     class="inputfield w-full"
                     [(ngModel)]="repeatPassword">
            </div>
            <p-button type="submit" class="" [disabled]="loading"
                      [label]="(!loading
                  ? translations.auth.recoverPassword
                  : translations.auth.loading) | translate"
            ></p-button>
          </form>
        </ng-template>
        <ng-template [ngIf]="passwordChanged">
          <p>
            {{ translations.auth.passwordChanged | translate }}
          </p>
        </ng-template>

      </div>

      <div class="surface-card py-4 px-5 sm:px-7 shadow-2 w-11 sm:w-30rem mt-4 mx-auto justify-content-center flex"
           style="border-radius:14px">
        <a pButton pRipple [href]="RoutingConstants.login">
          {{ translations.auth.loginQuestion | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
